import { SidebarContent } from "./";
import { SidebarDrawer } from "../drawer";

const Sidebar = () => {
    return (
        <>
            <SidebarContent />

            <SidebarDrawer />
        </>
    );
};

export default Sidebar;
